const PaddingTop = 24;
const PaddingBottom = 16;
const PaddingLeft = 16;
const PaddingRight = 16;

export const getDialogFullBorder = (_, { palette = {} }) => ({
  marginTop: 24,
  position: 'relative',

  '&:before': {
    content: '""',
    position: 'absolute',
    top: '-24px',
    left: `-${PaddingLeft}px`,
    right: `-${PaddingRight}px`,
    borderTop: `1px solid ${palette.neutralLight}`,
  },
});

export const getDialogStyle = (_, { palette = {} }) => ({
  '& .ms-Dialog-title': {
    padding: `${PaddingTop}px ${PaddingRight}px 12px ${PaddingLeft}px`,
  },
  '& .ms-Dialog-inner': {
    padding: `0 ${PaddingRight}px ${PaddingBottom}px ${PaddingLeft}px`,
    '& .ms-Dialog-subText': {
      padding: 0,
      margin: 0,
    },
    '& .ms-Dialog-actions': {
      ...getDialogFullBorder(_, { palette }),
    },
  },
});
